/**
 * @generated SignedSource<<078e7389f9c5288a5035aa92fb170fde>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OfflineLicenseTokenRequestStatus = "NONE" | "REQUESTED" | "%future added value";
export type OfflineLicenseTokenManagerRequestLicenseMutation$variables = {
  appId: string;
};
export type OfflineLicenseTokenManagerRequestLicenseMutation$data = {
  readonly requestAppOfflineLicense: {
    readonly id: string;
    readonly licenses: ReadonlyArray<{
      readonly expiresAt: string | null | undefined;
      readonly id: string;
      readonly token: string;
    }>;
    readonly offlineLicenseRequestStatus: OfflineLicenseTokenRequestStatus;
  };
};
export type OfflineLicenseTokenManagerRequestLicenseMutation = {
  response: OfflineLicenseTokenManagerRequestLicenseMutation$data;
  variables: OfflineLicenseTokenManagerRequestLicenseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appId",
        "variableName": "appId"
      }
    ],
    "concreteType": "App",
    "kind": "LinkedField",
    "name": "requestAppOfflineLicense",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "License",
        "kind": "LinkedField",
        "name": "licenses",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offlineLicenseRequestStatus",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OfflineLicenseTokenManagerRequestLicenseMutation",
    "selections": (v2/*:: as any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "OfflineLicenseTokenManagerRequestLicenseMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "6c8e9847bf3c15a9c60f3d3310cfa950",
    "id": null,
    "metadata": {},
    "name": "OfflineLicenseTokenManagerRequestLicenseMutation",
    "operationKind": "mutation",
    "text": "mutation OfflineLicenseTokenManagerRequestLicenseMutation(\n  $appId: ID!\n) {\n  requestAppOfflineLicense(appId: $appId) {\n    id\n    licenses {\n      id\n      expiresAt\n      token\n    }\n    offlineLicenseRequestStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "09f3b221e4971c26219dca0d7547bc59";

export default node;
